<template>
  <b-modal :active.sync="showNeedConfirmServiceAgreementModal"
           has-modal-card
           :can-cancel="false"
           :width="640">
    <div class="modal-card">
      <header class="modal-card-head has-background-success has-text-centered">
        <h2 class="modal-card-title has-text-white has-text-weight-bold">
          <p>Welcome to Enhancify Reports</p>
          <p>Your contractor dashboard</p></h2>
      </header>

      <div class="modal-card-foot">
        <div class="text">
          <p>We get it. We know most people don’t read terms and conditions but here at Enhancify we
            believe in transparency. Our guarantee to your company is if you run 10 applications
            within 30 days and we are unable to successfully provide loan options to your customers
            we will happily refund you.</p>
          <p>Just a reminder. Enhancify’s licensing is an annual subscription that automatically
            renews for your convenience. You will receive an email reminder and can also opt out
            at any time.</p>
        </div>
        <validation-observer ref="createCardObserver" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(frmAcceptServiceAgreementDate)">
            <b-field class="is-size-7">
              <b-checkbox v-model="acceptEnabled">In order to access your dashboard please
                review our updated
                <a href="https://www.enhancify.com/service-provider-agreement" rel="nofollow" target="_blank">Service Provider Agreement</a></b-checkbox>
            </b-field>
            <div class="card-form__panel buttons is-centered">
              <button
                class="button is-success"
                :disabled="!acceptEnabled">Accept
              </button>
            </div>
          </form>
            <section class="hero is-small">
              <div class="hero-body">
                <div class="container">
                  <h2 class="subtitle has-text-centered is-size-7">
                    Need Help? We are ready to help you with any request at
                    <a href="mailto:Support@Enhancify.com">Support@Enhancify.com</a> or
                    <a href="tel:+18132123073">813-212-3073</a>
                  </h2>
                </div>
              </div>
            </section>
        </validation-observer>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import { setConfirm } from '../../api/settings';

export default {
  name: 'ServiceAgreement',
  props: {
    sidebarOpened: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      acceptEnabled: false,
    };
  },
  methods: {
    submit() {
    },
    frmAcceptServiceAgreementDate() {
      setConfirm()
        .then((response) => {
          if (response.data.error) {
            this.toast(response.data.message, 'is-danger');
          } else {
            this.toast(response.data.message);
            this.$store.commit('RESET_NEED_CONFIRM', null, { root: true });
          }
        })
        .finally(() => { this.acceptEnabled = false; });
    },
    toast(message, type = 'is-success') {
      this.$buefy.toast.open({ message, type, duration: 5000 });
    },
  },
  computed: {
    ...mapState('contractor', { needConfirm: (state) => state.needConfirmServiceAgreement }),
    ...mapState('auth2', { authId: (state) => state.id }),
    ...mapState('user', { userId: (state) => state.id, isContractorUser: (state) => state.isContractorUser }),
    ...mapState('auth2', { contractor: (state) => state.contractor }),
    showNeedConfirmServiceAgreementModal: (state) => {
      if (
        (state.userId === state.authId)
        && state.contractor
        && state.needConfirm
        && state.isContractorUser
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="stylus">
.is-size-7
  font-size .9rem!important
.modal-card
  overflow auto
.modal-card-head
  padding 25px 20px 15px
.modal-card-title
  line-height 1.1
  font-size 1.3rem
  max-height 9001em
.b-checkbox a
  text-decoration underline
.modal-card-foot
  flex-direction column
  padding 15px 20px
  max-height 9001em
.text
  padding-bottom 10px
  max-height 9001em
  line-height: 1.3
.text p
  padding-bottom 15px
.hero.is-small .hero-body
  padding-bottom 0.5rem
  padding-top 1rem
</style>
